export const workoutdata=[
    {
        type : "Running",
        calories : 60,
        set:1,
        unit: "km",
    },
    {
        type:"Walking",
        calories:42,
        set:1,
        unit: "km",
    }
     ,
    {
        type : "Step walk",
        calories : 60,
        set:1000,
        unit: "steps",
    }
    ,
    {
        type:"Skiping",
        calories:70,
        set:500,
        unit: "skips",
    }
]